<ng-container *ngIf="csRangePicker; else singlePicker">
  <nz-range-picker #datePickerComponent class="w-100" [(ngModel)]="controlValue" [nzPlaceHolder]="csPlaceholder" [class.border-danger]="csIsError"
                  (ngModelChange)="onModelChange($event)" [nzFormat]="csFormat" [nzDefaultPickerValue]="csDefaultPickerValue"
                  [nzDisabled]="csDisable" [nzMode]="csMode" [nzLocale]="csLocale" [nzShowTime]="csShowTime ? timeFormat : false"
                  [nzDisabledDate]="csDisabledDate" [nzShowToday]="csShowToday" [nzSeparator]="'-'" [nzRanges]="ranges || rangesDate" [nzInline]="csInline"
                  [nzDropdownClassName]="csDropdownClassName" (nzOnCalendarChange)="onCalendarChange($event)" [nzSuffixIcon]="'icons:calendarQLCT'"
                  [nzAllowClear]="csAllowClear"
                  ></nz-range-picker>
</ng-container>
<ng-template #singlePicker>
  <nz-date-picker #datePickerComponent class="w-100" [(ngModel)]="controlValue" [nzPlaceHolder]="csPlaceHolder || 'DD/MM/YYYY'" [class.border-danger]="csIsError"
                  (ngModelChange)="onModelChange($event)" (input)="onBlur($event)" [nzFormat]="csFormat" [nzDefaultPickerValue]="csDefaultPickerValue"
                  [nzDisabled]="csDisable" [nzMode]="csMode" [nzLocale]="csLocale" [nzShowTime]="csShowTime ? timeFormat : false"
                  [nzDisabledDate]="csDisabledDate" [nzShowToday]="csShowToday" [nzInline]="csInline"
                  [nzSuffixIcon]="'icons:calendarQLCT'"
                  [nzAllowClear]="csAllowClear"
  >
    <!-- <ng-template #nzSuffixIcon>
      <i nz-icon nzType="'icons:calendarQLCT'" nzTheme="outline"></i>
    </ng-template> -->
  </nz-date-picker>
</ng-template>
